import svEllipsis from './sv-ellipsis.vue'
export default svEllipsis